import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Container } from 'reactstrap'
import { graphql } from 'react-apollo'

import {
  AppAside,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav
} from '@coreui/react'

import me from '../../queries/me.js'
// sidebar nav config
// import navigation from '../../_nav'
import navigationAdmin from '../../_navSA'
// routes config
import routes from '../../routes'

import DefaultAside from './DefaultAside'
// import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader'

class DefaultLayout extends Component {
  constructor (props) {
    super(props)
    this.events = [
      'load',
      'mousemove',
      'mousedown',
      'click',
      'scroll',
      'keypress'
    ]
    this.logout = this.logout.bind(this)
  }

  logout () {
    localStorage.removeItem('token')
    this.props.history.push(`/login`)
  }

  render () {
    const { history, data } = this.props
    // console.log(this.props, "props default header")
    if (!localStorage.getItem('token')) {
      history.push(`/login`)
    }
    if (data.loading) {
      return <div />
    }

    const user = data.me
    const role = user.role
    const hasTaller = user.hasTaller
    const hasTallerA = user.hasTallerA
    // let role = localStorage.getItem('role');
    return (
      <div className='app'>
        <AppHeader fixed>
          <DefaultHeader data={data} history={history} />
        </AppHeader>
        <div className='app-body'>
          {(role === 'ADMIN' || role === 'EVALUATOR') && (
            <AppSidebar fixed>
              <AppSidebarHeader />
              <AppSidebarForm />
              <AppSidebarNav navConfig={navigationAdmin} {...this.props} />
              <AppSidebarFooter />
            </AppSidebar>
          )}
          <main className='main'>
            {/* <AppBreadcrumb appRoutes={routes}/> */}
            <Container fluid style={{ marginTop: '30px' }}>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component && (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <route.component
                          {...props}
                          hasTaller={hasTaller}
                          hasTallerA={hasTallerA}
                        />
                      )}
                    />
                  )
                })}
                <Redirect from='/' to='/login' />
              </Switch>
            </Container>
          </main>
          <AppAside fixed>
            <DefaultAside />
          </AppAside>
        </div>
        {/* <AppFooter>
          <DefaultFooter />
        </AppFooter> */}
      </div>
    )
  }
}

export default graphql(me)(DefaultLayout)
